import React from 'react';

import { Typography, Divider } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { CommonStyles } from '@kamernet/styles/CommonStyles';

import { useListingSelectors } from '@kamernet/modules/Listing/context/hooks/useListingSelectors';

import { CarouselGenerator } from '../../CarouselGenerator/CarouselGenerator';

const FeaturedListingsInternal = () => {
  const { T } = useIntl();
  const topAdListings = useListingSelectors().getFeaturedListings();
  return (
    <section className={CommonStyles.margin_bottom_4}>
      {topAdListings && topAdListings.length > 0 && (
        <React.Fragment>
          <Divider className={CommonStyles.margin_bottom_3} />
          <Typography variant="h5" className={CommonStyles.padding_block_1}>
            {T('LBL_FEATURED_TOP_ADS')}
          </Typography>
          <CarouselGenerator listings={topAdListings} />
          <Divider className={CommonStyles.margin_bottom_3} />
        </React.Fragment>
      )}
    </section>
  );
};
export const FeaturedListings = React.memo(FeaturedListingsInternal);
